import React, { useMemo } from 'react'
import _ from 'lodash';
import QualysWebappMappingForm_v1, { parseQualysNames } from './QualysWebappMappingForm_v1';
import QualysWebappCredentialsForm from './QualysWebappCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { CellRenderers } from 'utils/tableUtils';
import ContentOverlay from 'components/ContentOverlay';

// Renders names from appNameJson/tagNameJson (JSON array) or falls back to legacy comma-separated field.
const qualysNameRenderer = (jsonValue, record, legacyField) => {
    const raw = jsonValue || (record && record[legacyField]);
    if (_.isEmpty(raw)) return CellRenderers.VALUE_OR_NA(null);
    const items = parseQualysNames(raw);
    const nonEmpty = items.map(s => typeof s === 'string' ? s.trim() : s).filter(Boolean);
    if (nonEmpty.length === 0) return CellRenderers.VALUE_OR_NA(null);
    const renderName = nonEmpty.map((item, i) => (
        <p key={i} className={i === nonEmpty.length - 1 ? "m-b-0" : "m-b-xs"}>{item}</p>
    ));
    return <ContentOverlay content={renderName} minHeight={40} />;
};

// Formats JSON array filter labels into readable comma-separated names.
const qualysFilterLabelFormatter = (label) => {
    const items = parseQualysNames(label);
    const nonEmpty = items.map(s => typeof s === 'string' ? s.trim() : s).filter(Boolean);
    return nonEmpty.length > 0 ? nonEmpty.join(', ') : label;
};

export default function QualysWebappConfigListing(props) {
    const columns = useMemo(() => [
        {
            title: "App Name",
            dataIndex: "appNameJson",
            width: 240,
            render: (val, record) => qualysNameRenderer(val, record, "appName"),
            filterLabelFormatter: qualysFilterLabelFormatter
        },
        {
            title: "Tag Name",
            dataIndex: "tagNameJson",
            width: 240,
            render: (val, record) => qualysNameRenderer(val, record, "tagName"),
            filterLabelFormatter: qualysFilterLabelFormatter
        }
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={QualysWebappMappingForm_v1}
            CredentialsForm={QualysWebappCredentialsForm}
            extraColumns={columns}
        />
    )
}
